export const getDirector = (
  id: number
): {
  name: string
  roma: string
  iconImagePath: string
  nameImagePath: string
  textLinkPath: string
} => {
  if (id % 2 === 0)
    return {
      name: '奥谷',
      roma: 'okuya',
      iconImagePath:
        'https://s3.lifedot.jp/uploads/ending/path/60543/director_icon_okuya.png',
      nameImagePath:
        'https://s3.lifedot.jp/uploads/ending/path/61117/director_name_okuya.png',
      textLinkPath: '/okuya-kenta/'
    }
  return {
    name: '小野寺',
    roma: 'onodera',
    iconImagePath:
      'https://s3.lifedot.jp/uploads/ending/path/60544/director_icon_onodera.png',
    nameImagePath:
      'https://s3.lifedot.jp/uploads/ending/path/61116/director_name_onodera.png',
    textLinkPath: '/supervision-person/'
  }
}
